import { useMemo } from 'react'
import type { IScheduleSettingsDetail } from '../typings'
import { checkSchedulingVisibility } from '@user/store/scheduling'

export function useSchedulingVisibility(settings?: IScheduleSettingsDetail) {
  return useMemo(() => checkSchedulingVisibility(settings), [settings])
}
